export default {"src":"/_next/static/media/contact-us.9518020d.svg","height":200,"width":400};